<template>
  <div class="box">
    <div class="floor1">
      <div class="content">
        <img src="../../assets/img/introduction/yh.svg" alt="" class="yh" />
        <img
          src="../../assets/img/introduction/m5.svg"
          alt=""
          class="descroption"
        />
        <div class="title">Loan guide</div>
      </div>
    </div>
    <div class="floor2">
      <div class="title">Group saving with higher interest</div>
      <div class="list">
        <!-- We provide quick loans from Ksh 2,000 to Ksh 30,000 and the repayment
        period ranging from 7 days to 180 days. The interest of Kinvest is from
        1.5% per week, APR is 78% only. It is the lowest among all the loan apps
        with their APR ranging from 226% to 334%. Anytime and anywhere, you
        could get the quick loan service from Kinvest, all around the clock,
        from Monday to Sunday. -->
        We provide quick loans from Ksh 2,000 to Ksh 30,000 and the repayment
        period ranging from 91 days to 180 days. The interest of Kinvest is from
        1.5% per week, APR is 78%. Anytime and anywhere, you could get the quick
        loan service from Kinvest, all around the clock, from Monday to Sunday.
      </div>
      <div class="list">
        Borrow money on the go with the Kinvest app. Instant cash is available
        to you at any time! Take advantage of a quick loan whenever you need
        it.<br /><br />
        Apply for loans in a few taps when you have our app installed on your
        phone. Take advantage of the simple, fast, and safe application. If cash
        is what you are seeking at the moment, our app is your best choice!
      </div>
      <div class="list">
        <!-- A representative example of the total loan cost (all applicable fees are
        included):<br />
        Loan amount - Ksh 3,000; loan term - 12 weeks; total interest - 18%;
        <br />
        Your monthly repayment is Ksh 295. The total amount payable is Ksh
        3,540. The total interest is Ksh 540. You need to freeze the deposit of
        Ksh 1,500 and unfreeze the deposit after the loan is paid off. If the
        loan is not repaid in time, we will deduct it from your guaranteed
        amount. -->
      </div>
      <div class="list">
        Loans can help you solve emergency expenses, pay unforeseen bills, cover
        urgent costs, or just get a few to make ends meet until payday. No
        matter what your reasons are, be responsible and attentive applying for
        any financial solutions, even if it’s just a small loan. Apply today and
        get money fast!
      </div>
    </div>
    <div class="el-loading-mask" v-if="!hasToken">
      You are not logged in. Please log in to view the page
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      hasToken: false,
    };
  },
  created() {
    let o = this.$route.query;
    if (o.token) {
      this.hasToken = true;
    } else {
      this.hasToken = false;
    }
  },
};
</script>
<style lang="scss" scoped>
@import url("../../assets/css/index.css");
.box {
  margin: 0 auto;
  width: 100%;
  max-width: 600px;
  background-color: #f9f9f9;
  padding-top: 100px;
  padding-bottom: 20px;
  position: relative;
  .floor1 {
    width: 100%;
    height: 300px;
    background: linear-gradient(
      180deg,
      #f4f5ff 0%,
      rgba(249, 250, 255, 0) 100%
    );
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    .content {
      width: 100%;
      position: relative;
      .yh {
        position: absolute;
        left: 16px;
        top: 20px;
        z-index: 1;
        height: 40px;
      }
      .descroption {
        position: absolute;
        top: 0;
        right: 16px;
        width: 109px;
      }
      .title {
        position: absolute;
        left: 16px;
        top: 44px;
        font-size: 24px;
        font-family: "rb";
        font-weight: bold;
        color: #333333;
        line-height: 28px;
        z-index: 2;
      }
    }
  }
  .floor2 {
    padding: 24px 16px 8px;
    background: #ffffff;
    border-radius: 2px;
    margin: 0 16px;
    position: relative;
    z-index: 100;
    .title {
      font-size: 16px;
      font-family: "rm";
      font-weight: 500;
      color: #303f49;
      line-height: 19px;
      margin-bottom: 24px;
      position: relative;
      &::before {
        position: absolute;
        content: " ";
        left: 0;
        top: 12px;
        width: 38px;
        height: 10px;
        background: #e7e9ff;
        z-index: -1;
      }
    }
    .list {
      padding-left: 10px;
      font-size: 12px;
      font-family: "rr";
      font-weight: 400;
      color: #50616c;
      line-height: 21px;
      margin-bottom: 16px;
      position: relative;
      &::before {
        content: " ";
        left: 0;
        top: 9px;
        position: absolute;
        width: 5px;
        height: 5px;
        background: #d8d8d8;
        border-radius: 100%;
      }
    }
  }
}
</style>
